import { store } from 'crazyEditor/redux/store';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { addDesktopElement as addDesktopElementAction } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { shouldOpenElementDialog } from 'crazyEditor/core/elements/utils/elementDialogUtils';
import { getElementPanel, getElementDefinitionProps, isTextElement, isElementEditable } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { TYPES, DATA_PANELS } from 'crazyEditor/core/constants/panelConstants';
import { setEditingTextElementId } from 'crazyEditor/redux/modules/stage/stage';
import _ from 'lodash';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import {isDraft} from 'crazyEditor/redux/modules/element/elementSelectors';

function openLazyDialogPanel(elementType, elementPosition = null, newElement = false, selectedElement = null) {
  store.dispatch(openLazyPanel(getElementPanel(elementType), TYPES.DATA_PANEL, {}, {
    elementType,
    elementPosition,
    newElement,
    selectedElement
  }));
}

export function isEditable(element, newElement = false) {
  const {type} = element;
  if (_.get(element, 'data.templateTag')) {
    switch (type) {
      case elementTypes.GalleryElement:
        const bulkReviseEnabled = store.getState().user.bulkReviseEnabled;
        if (!bulkReviseEnabled) {
          return false;
        }
        const isListing = isDraft(store.getState()) || !_.isEmpty(element.data.listingData);
        return isListing ? true : !newElement;
      default:
        return !_.isEmpty(element.data.listingData) || isDraft(store.getState());
    }
  }
  return (shouldOpenElementDialog(type) || isTextElement(type));
}

export function addDesktopElement(elementType, elementPosition = null, elementProps = null) {
  if (shouldOpenElementDialog(elementType, elementProps) && isEditable(elementProps, true)) {
    openLazyDialogPanel(elementType, elementPosition, true);
  } else {
    store.dispatch(addDesktopElementAction(elementType, elementPosition, elementProps));
  }
}

export function editDesktopElement(element) {
  if (!isEditable(element)) {
    return;
  }
  const elementType = element.type;
  const elementId = element.id;
  if (shouldOpenElementDialog(elementType)) {
    openLazyDialogPanel(elementType, null, false, element);
  } else if (isTextElement(elementType)) {
    store.dispatch(setEditingTextElementId(elementId));
  }
}
